import styled from "styled-components";

const MagazineBlockSmallImage = styled.div`
  width: 80px;
  height: 80px;
  margin-left: 10px;
  background-image: url(${props => props.image});
  background-size: cover;
  background-position: center;
  border-radius: 6px;
`;

MagazineBlockSmallImage.defaultProps = {};

export { MagazineBlockSmallImage };
